export const ZOHO_READ_SCOPES = [
  "ZohoCRM.org.READ",
  "ZohoCRM.users.READ",
  "ZohoCRM.settings.READ",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.READ",
];

export const ZOHO_UPDATE_SCOPES = [
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.modules.UPDATE",
];

export const ZOHO_WRITE_SCOPES = [
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.modules.CREATE",
];

export const ZOHO_DELETE_SCOPES = [
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.modules.CREATE",
];

export const OLD_ZOHO_SCOPES = [
  "ZohoCRM.users.CREATE",
  "ZohoCRM.users.READ",
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.org.READ",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.settings.READ",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.CREATE",
  "ZohoCRM.modules.READ",
  "ZohoCRM.modules.UPDATE",
  "ZohoCRM.modules.attachments.ALL",
];

export const OLD_ZOHO_WORKDRIVE_SCOPES = [
  "ZohoSearch.securesearch.READ",
  "WorkDrive.collection.READ",
  "WorkDrive.comments.READ",
  "WorkDrive.files.READ",
  "WorkDrive.users.READ",
  "WorkDrive.groups.READ",
  "WorkDrive.members.READ",
  "WorkDrive.organization.READ",
  "WorkDrive.team.READ",
  "WorkDrive.teamfolders.admin.READ",
  "WorkDrive.teamfolders.READ",
  "WorkDrive.teamfolders.sharing.READ",
  "WorkDrive.workspace.READ",
  "ZohoCRM.users.READ",
  "ZohoCRM.org.READ",
  "ZohoCRM.settings.READ",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.READ",
  "WorkDrive.collection.CREATE",
  "WorkDrive.comments.CREATE",
  "WorkDrive.DataTemplates.CREATE",
  "WorkDrive.files.CREATE",
  "WorkDrive.groups.CREATE",
  "WorkDrive.members.CREATE",
  "WorkDrive.team.CREATE",
  "WorkDrive.teamfolders.CREATE",
  "WorkDrive.teamfolders.sharing.CREATE",
  "WorkDrive.workspace.CREATE",
  "ZohoCRM.users.CREATE",
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.modules.CREATE",
  "WorkDrive.collection.UPDATE",
  "WorkDrive.comments.UPDATE",
  "WorkDrive.DataTemplates.UPDATE",
  "WorkDrive.files.UPDATE",
  "WorkDrive.groups.UPDATE",
  "WorkDrive.members.UPDATE",
  "WorkDrive.team.UPDATE",
  "WorkDrive.teamfolders.UPDATE",
  "WorkDrive.teamfolders.sharing.UPDATE",
  "WorkDrive.workspace.UPDATE",
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.modules.UPDATE",
  "WorkDrive.files.ALL",
  "WorkDrive.files.DELETE",
];

export const ZOHO_SCOPES = [
  "ZohoCRM.users.READ",
  "ZohoCRM.org.READ",
  "ZohoCRM.settings.READ",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.CREATE",
  "ZohoCRM.modules.READ",
  "ZohoCRM.modules.UPDATE",
  "ZohoCRM.modules.attachments.ALL",
];

export const ZOHO_WORKDRIVE_SCOPES = [
  "ZohoCRM.users.READ",
  "ZohoCRM.org.READ",
  "ZohoSearch.securesearch.READ",
  "WorkDrive.collection.READ",
  "WorkDrive.comments.READ",
  "WorkDrive.files.READ",
  "WorkDrive.users.READ",
  "WorkDrive.groups.READ",
  "WorkDrive.members.READ",
  "WorkDrive.organization.READ",
  "WorkDrive.team.READ",
  "WorkDrive.teamfolders.admin.READ",
  "WorkDrive.teamfolders.READ",
  "WorkDrive.teamfolders.sharing.READ",
  "WorkDrive.workspace.READ",
  "WorkDrive.files.CREATE",
  "WorkDrive.files.UPDATE",
  "WorkDrive.teamfolders.UPDATE",
  "WorkDrive.teamfolders.sharing.UPDATE",
  "WorkDrive.files.ALL",
];

export const ZOHO_WORKDRIVE_READ_SCOPES = [
  "ZohoSearch.securesearch.READ",
  "WorkDrive.collection.READ",
  "WorkDrive.comments.READ",
  "WorkDrive.files.READ",
  "WorkDrive.users.READ",
  "WorkDrive.groups.READ",
  "WorkDrive.members.READ",
  "WorkDrive.organization.READ",
  "WorkDrive.team.READ",
  "WorkDrive.teamfolders.admin.READ",
  "WorkDrive.teamfolders.READ",
  "WorkDrive.teamfolders.sharing.READ",
  "WorkDrive.workspace.READ",
  "ZohoCRM.users.READ",
  "ZohoCRM.org.READ",
  "ZohoCRM.settings.READ",
  "ZohoCRM.coql.READ",
  "ZohoCRM.modules.READ",
];

export const ZOHO_WORKDRIVE_CREATE_SCOPES = [
  "WorkDrive.collection.CREATE",
  "WorkDrive.comments.CREATE",
  "WorkDrive.DataTemplates.CREATE",
  "WorkDrive.files.CREATE",
  "WorkDrive.groups.CREATE",
  "WorkDrive.members.CREATE",
  "WorkDrive.team.CREATE",
  "WorkDrive.teamfolders.CREATE",
  "WorkDrive.teamfolders.sharing.CREATE",
  "WorkDrive.workspace.CREATE",
  "ZohoCRM.users.CREATE",
  "ZohoCRM.settings.CREATE",
  "ZohoCRM.modules.CREATE",
];

export const ZOHO_WORKDRIVE_UPDATE_SCOPES = [
  "WorkDrive.collection.UPDATE",
  "WorkDrive.comments.UPDATE",
  "WorkDrive.DataTemplates.UPDATE",
  "WorkDrive.files.UPDATE",
  "WorkDrive.groups.UPDATE",
  "WorkDrive.members.UPDATE",
  "WorkDrive.team.UPDATE",
  "WorkDrive.teamfolders.UPDATE",
  "WorkDrive.teamfolders.sharing.UPDATE",
  "WorkDrive.workspace.UPDATE",
  "ZohoCRM.users.UPDATE",
  "ZohoCRM.org.UPDATE",
  "ZohoCRM.settings.UPDATE",
  "ZohoCRM.modules.UPDATE",
];

export const ZOHO_WORKDRIVE_DELETE_SCOPES = ["WorkDrive.files.DELETE"];

export const GOOGLE_SCOPES = [
  "https://www.googleapis.com/auth/drive.file",
  "https://www.googleapis.com/auth/drive.metadata",
  "https://www.googleapis.com/auth/drive",
];

export const DROPBOX_SCOPES = [
  "account_info.write",
  "account_info.read",
  "files.metadata.write",
  "files.metadata.read",
  "files.content.write",
  "files.content.read",
  "sharing.write",
  "sharing.read",
  "file_requests.write",
  "file_requests.read",
];

export const SHAREPOINT_READ_SCOPES = [
  "Files.Read.All",
  "User.Read",
  "Sites.Read.All",
  "offline_access",
];

export const SHAREPOINT_UPDATE_SCOPES = [];

export const SHAREPOINT_DELETE_SCOPES = [];

export const SHAREPOINT_CREATE_SCOPES = [
  "Files.ReadWrite.All",
  "User.Read",
  "Sites.ReadWrite.All",
];

export const SHAREPOINT_SCOPES = [
  "Files.ReadWrite.All",
  "User.Read",
  "Sites.ReadWrite.All",
  "offline_access",
];

export const ONEDRIVE_SCOPES = [
  "Files.ReadWrite.All",
  "User.Read",
  "Sites.ReadWrite.All",
  "offline_access",
];

export const MICROSOFT_365_MAIL_SCOPES = [
  "Mail.ReadWrite",
  "Mail.Send",
  "User.Read",
  "offline_access",
];

export const CLIQ_SCOPES = [
  "ZohoCliq.Messages.READ",
  "ZohoCliq.Channels.UPDATE",
  "ZohoCliq.Channels.CREATE",
  "ZohoCliq.Chats.ALL",
  "ZohoCliq.Teams.READ",
  "ZohoCliq.Users.READ",
  "ZohoCliq.Buddies.READ",
  "ZohoCliq.Chats.READ",
  "ZohoCliq.Profile.CREATE",
  "ZohoCliq.Webhooks.CREATE",
  "ZohoCliq.Reminders.READ",
  "ZohoCliq.Channels.READ",
];
